import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { App } from './App';
import { ConsultationPage } from './components/ConsultationPage';
export function AppRouter() {
  return <BrowserRouter data-id="element-13">
      <Routes data-id="element-14">
        <Route path="/" element={<App data-id="element-16" />} data-id="element-15" />
        <Route path="/consultation" element={<ConsultationPage data-id="element-18" />} data-id="element-17" />
      </Routes>
    </BrowserRouter>;
}